import { createGlobalStyle } from 'styled-components';

export const TextStyle = createGlobalStyle`
.fw-400 {
  font-weight: 400;
}
.fw-500 {
  font-weight: 500;
}
.fw-600 {
  font-weight: 600;
}
.fw-700 {
  font-weight: 700;
}
.fw-bold {
  font-weight: 600;
}

.note {
  font-size:  var(--font-text-sm);
  color: var(--text-primary);
  opacity: 0.88;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align:right;
}

.underline {
  text-decoration: underline;
}

.text-primary {
  color: var(--text-primary);
}

.text-secondary {
  color: var(--text-secondary);
}
.text-highlight {
  color:var(--primary);
}

.text-active-green {
  color: var(--text-active-green);
}

.text-sub-title-gray {
  color: var(--text-sub-title-gray)
}

.text-inactive-red {
  color: var(--text-inactive-red);
}

.title-gray-color {
  color: var(--text-title-gray);
}

.title-theme-gray-color {
  color: var(--text-theme-gray);
}

.text-gray-second-color {
  color: var(--text-subtitle-gray);
}
.text-subtitle-gray {
  color: var(--text-subtitle-gray);
}
.opacity-10 {
  opacity: 10%;
}

.opacity-06 {
    opacity: 0.6;
  }

.text-active-grey-color {
  color: var(--text-active-grey);
}

.text-empty-gray-color {
  color: var(--text-empty-gray);
}

.text-white {
  color: var(--text-white)
}

.text-highlight-secondary {
  color: var(--secondary);
}

.text-active-grey {
  color: var(--text-active-grey);
}

.text-xs {
  font-size: var(--font-size-xs);
}

.text-tab-title {
  color: var(--text-tab-title);
}

.text-light-gray {
  color: var(--text-light-gray);
}

.color-dark-gray {
  color: var(--color-dark-gray);
}

.text-error-red {
  color: var(--text-error-red)
}

.line-height-normal {
  line-height: normal;
}
.line-18 {
  line-height: 18px;
}
  .text-hover:hover {
    color: var(--primary);
    text-decoration: underline;
  }

  .underline-hover:hover {
    text-decoration: underline;
  }

  .text-pre-line {
    white-space: pre-line;
  }

  .break-word {
    word-break: break-word;
  }
`;
